var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoConversionSettings = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "btn_taxes_and_commision24x24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10752",
    "data-name": "Rectangle 10752",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "currency",
    transform: "translate(4 4)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48339",
    "data-name": "Path 48339",
    d: "M9.026,6.306h0A4.662,4.662,0,1,0,6.308,9.029,5.641,5.641,0,0,1,9.026,6.306Zm-3.892.9v.531a.472.472,0,0,1-.944,0V7.205a1.8,1.8,0,0,1-1.153-.321.472.472,0,0,1,.539-.776.824.824,0,0,0,.451.153H5.238a.562.562,0,0,0,0-1.124H4.086a1.508,1.508,0,1,1,.1-3.013V1.594a.472.472,0,0,1,.944,0v.531a1.765,1.765,0,0,1,1.332.562.472.472,0,1,1-.689.646.815.815,0,0,0-.58-.263H4.086a.562.562,0,0,0,0,1.124H5.166a1.509,1.509,0,1,1-.031,3.013Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48340",
    "data-name": "Path 48340",
    d: "M218.482,213.64a4.665,4.665,0,1,0,4.662,4.665A4.668,4.668,0,0,0,218.482,213.64Zm2.1,7.176a.472.472,0,0,1-.593.307,4.521,4.521,0,0,0-2.745,0,.473.473,0,0,1-.54-.684,4.537,4.537,0,0,0,.531-1.572h-.407a.472.472,0,0,1,0-.944h.442c-.009-.132-.015-.176-.059-.576a1.7,1.7,0,0,1,2.965-1.315.472.472,0,0,1-.707.626.758.758,0,0,0-1.319.586c.044.4.056.488.066.679h.66a.472.472,0,0,1,0,.944h-.689a5.435,5.435,0,0,1-.261,1.142,5.427,5.427,0,0,1,2.348.21.472.472,0,0,1,.307.593Z",
    transform: "translate(-207.144 -206.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48341",
    "data-name": "Path 48341",
    d: "M357.722,18.7a1.9,1.9,0,0,1,1.9,1.987v.441l-.423-.423a.472.472,0,1,0-.668.668l1.229,1.229a.472.472,0,0,0,.668,0h0l1.229-1.229a.472.472,0,0,0-.668-.668l-.423.423v-.441a2.848,2.848,0,0,0-2.848-2.931.472.472,0,1,0,0,.944Z",
    transform: "translate(-346.059 -17.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48342",
    "data-name": "Path 48342",
    d: "M12.312,337.914a1.9,1.9,0,0,1-1.9-1.987v-.441l.423.423a.472.472,0,0,0,.668-.668l-1.229-1.229h0a.471.471,0,0,0-.668,0h0l-1.229,1.229a.472.472,0,0,0,.668.668l.423-.423v.441a2.848,2.848,0,0,0,2.848,2.931.472.472,0,0,0,0-.944Z",
    transform: "translate(-7.976 -323.418)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoConversionSettings);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_conversion_settings.0c682786f8bb494fb9bb9eefef774b3c.svg";